import { render, staticRenderFns } from "./PatrolStaffMaster.vue?vue&type=template&id=94ddede2&scoped=true&"
import script from "./PatrolStaffMaster.vue?vue&type=script&lang=js&"
export * from "./PatrolStaffMaster.vue?vue&type=script&lang=js&"
import style0 from "./PatrolStaffMaster.vue?vue&type=style&index=0&id=94ddede2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ddede2",
  null
  
)

export default component.exports